import { useCallback } from 'react';
import useShiftWS from '../../../hooks/useShiftWS';

interface UseShiftSyncDeps {
  fetchTableShifts: () => Promise<any>;
}

export function useShiftSync(deps: UseShiftSyncDeps) {
  const { fetchTableShifts } = deps;

  const handleNewApplication = useCallback(() => {
    setTimeout(() => fetchTableShifts(), 150);
  }, [fetchTableShifts]);

  const handleApplicationDeleted = useCallback(() => {
    setTimeout(() => fetchTableShifts(), 150);
  }, [fetchTableShifts]);

  const handleNewAssignment = useCallback(() => {
    setTimeout(() => fetchTableShifts(), 150);
  }, [fetchTableShifts]);

  useShiftWS({
    onNewApplication: handleNewApplication,
    onApplicationDeleted: handleApplicationDeleted,
    onNewAssignment: handleNewAssignment,
  });
}
